// extracted by mini-css-extract-plugin
export default {"wrapper":"DatePickerQuicklFilters--wrapper--94f407","filter":"DatePickerQuicklFilters--filter--62ee14"};